export enum ControlType {
    YesNo = 1,
    DropDown = 2,
    Header = 3,
    Text = 4
}
